import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const RentalCarPage = () => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate('/');
  }, []);
  return <></>;
};
export default RentalCarPage;
